export var countryList = [
  "Globally",
  "Abkhazia",
  "Afghanistan",
  "Albania",
  "Algeria",
  "Andorra",
  "Angola",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegovina",
  "Botswana",
  "Brazil",
  "Brunei",
  "Bulgaria",
  "Burkina Faso",
  "Burma",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Colombia",
  "Comoros",
  "Congo",
  "Cook Islands",
  "Costa Rica",
  "Croatia",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Côte d'Ivoire",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Fiji",
  "Finland",
  "France",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Greece",
  "Grenada",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Honduras",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Ivory Coast",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, North",
  "Korea, South",
  "Kosovo",
  "Kuwait",
  "Kyrgyzstan",
  "Laos",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macedonia",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Mauritania",
  "Mauritius",
  "Mexico",
  "Micronesia",
  "Moldova",
  "Monaco",
  "Mongolia",
  "Montenegro",
  "Morocco",
  "Mozambique",
  "Myanmar / Burma",
  "Nagorno-Karabakh",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Northern Cyprus",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Palestine",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Poland",
  "Portugal",
  "Qatar",
  "Romania",
  "Russia",
  "Rwanda",
  "Sahrawi Arab Democratic Republic",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Saudi Arabia",
  "Senegal",
  "Serbia",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "Somaliland",
  "South Africa",
  "South Ossetia",
  "Spain",
  "Sri Lanka",
  "Sudan",
  "Suriname",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syria",
  "São Tomé and Príncipe",
  "Taiwan",
  "Tajikistan",
  "Tanzania",
  "Thailand",
  "Timor-Leste / East Timor",
  "Togo",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Vatican City",
  "Venezuela",
  "Vietnam",
  "Yemen",
  "Zambia",
  "Zimbabwe",
  "Other",
];

export var worldCities = {
  "United States": ["New York", "Los Angeles", "Chicago", "San Francisco"],
  "Canada": ["Toronto", "Vancouver"],
  "Mexico": ["Mexico City"],
  "Brazil": ["São Paulo", "Rio de Janeiro"],
  "Argentina": ["Buenos Aires"],
  "United Kingdom": ["London", "Manchester"],
  "France": ["Paris"],
  "Germany": ["Berlin", "Munich"],
  "Netherlands": ["Amsterdam"],
  "Belgium": ["Brussels"],
  "Switzerland": ["Zurich", "Geneva"],
  "Austria": ["Vienna"],
  "Spain": ["Madrid", "Barcelona"],
  "Italy": ["Rome", "Milan"],
  "Sweden": ["Stockholm"],
  "Denmark": ["Copenhagen"],
  "Norway": ["Oslo"],
  "Finland": ["Helsinki"],
  "Ireland": ["Dublin"],
  "Portugal": ["Lisbon"],
  "Czech Republic": ["Prague"],
  "Poland": ["Warsaw"],
  "Hungary": ["Budapest"],
  "Russia": ["Moscow"],
  "Türkiye": ["Istanbul"],
  "United Arab Emirates": ["Dubai", "Abu Dhabi"],
  "Saudi Arabia": ["Riyadh"],
  "Qatar": ["Doha"],
  "Kuwait": ["Kuwait City"],
  "Oman": ["Muscat"],
  "Bahrain": ["Manama"],
  "Israel": ["Tel Aviv"],
  "Egypt": ["Cairo"],
  "South Africa": ["Johannesburg", "Cape Town"],
  "Kenya": ["Nairobi"],
  "Nigeria": ["Lagos"],
  "Morocco": ["Casablanca"],
  "Ethiopia": ["Addis Ababa"],
  "Singapore": ["Singapore"],
  "Hong Kong SAR": ["Hong Kong"],
  "China": ["Beijing", "Shanghai", "Shenzhen", "Guangzhou"],
  "Japan": ["Tokyo", "Osaka"],
  "South Korea": ["Seoul", "Busan"],
  "Taiwan": ["Taipei"],
  "Thailand": ["Bangkok"],
  "Malaysia": ["Kuala Lumpur"],
  "Indonesia": ["Jakarta"],
  "Philippines": ["Manila"],
  "Vietnam": ["Ho Chi Minh City", "Hanoi"],
  "Cambodia": ["Phnom Penh"],
  "Myanmar": ["Yangon"],
  "Australia": ["Sydney", "Melbourne", "Brisbane", "Perth"],
  "New Zealand": ["Auckland", "Wellington"],
};

export var cityList = [
  "Abohar",
  "Agartala",
  "Ahmadnagar",
  "Ahmedabad",
  "Aizawl",
  "Ajmer",
  "Akola",
  "Allahabad",
  "Alleppey",
  "Alwar",
  "Aligarh",
  "Alipur Duar",
  "Ambala",
  "Amritsar",
  "Amravati",
  "Aurangabad",
  "Bahraigh",
  "Barddhaman",
  "Bareilly",
  "Belgaum",
  "Bellary",
  "Bengaluru",
  "Bezwada",
  "Bharatpur",
  "Bhilai",
  "Bhiwandi",
  "Bhiwani",
  "Bhopal",
  "Bhubaneshwar",
  "Bhuj",
  "Bhusaval",
  "Bhagalpur",
  "Bhatpara",
  "Bhavnagar",
  "Bhilwara",
  "Bijapur",
  "Bilaspur",
  "Brahmapur",
  "Budaun",
  "Bulandshahr",
  "Burhanpur",
  "Baramula",
  "Bidar",
  "Bikaner",
  "Calicut",
  "Cawnpore",
  "Chandigarh",
  "Chennai",
  "Chanda",
  "Chirala",
  "Coimbatore",
  "Conjeeveram",
  "Cuddalore",
  "Cuttack",
  "Daman",
  "Davangere",
  "Dehra Dun",
  "Delhi",
  "Dhanbad",
  "Dhulia",
  "Dibrugarh",
  "Dindigul",
  "Dispur",
  "Diu",
  "Etawah",
  "Faridabad",
  "Fatehpur",
  "Fyzabad",
  "Firozabad",
  "Gangtok",
  "Gaya",
  "Ghandinagar",
  "Ghaziabad",
  "Gorakhpur",
  "Gulbarga",
  "Guntur",
  "Gurugram",
  "Guwahati",
  "Gwalior",
  "Haldia",
  "Haripur",
  "Hindupur",
  "Hisar",
  "Hospet",
  "Hubli",
  "Hyderabad",
  "Haora",
  "Hapur",
  "Hathras",
  "Imphal",
  "Indore",
  "Itanagar",
  "Jabalpur",
  "Jaipur",
  "Jalandhar",
  "Jammu",
  "Jamshedpur",
  "Jhansi",
  "Jodhpur",
  "Jorhat",
  "Kalyan",
  "Kanpur",
  "Karnal",
  "Karimnagar",
  "Karur",
  "Kavaratti",
  "Khammam",
  "Kochi",
  "Kohima",
  "Kolhapur",
  "Kolkata",
  "Kolar",
  "Kota",
  "Krishnanagar",
  "Kumbakonam",
  "Kurnool",
  "Kakinada",
  "Lucknow",
  "Ludhiana",
  "Latur",
  "Machilipatnam",
  "Madura",
  "Mandya",
  "Mangalore",
  "Mathura",
  "Medinipur",
  "Meerut",
  "Mirzapur",
  "Moradabad",
  "Mumbai",
  "Muzaffarnagar",
  "Muzaffarpur",
  "Mysore",
  "Malegaon",
  "Nandyal",
  "Navsari",
  "Nellore",
  "New Delhi",
  "Nizamabad",
  "Nagercoil",
  "Nagpur",
  "Nanded",
  "Nasik",
  "Ongole",
  "Other",
  "Panaji",
  "Parbhani",
  "Pathankot",
  "Patiala",
  "Patna",
  "Porbandar",
  "Port Blair",
  "Proddatur",
  "Puducherry",
  "Pune",
  "Puri",
  "Purnea",
  "Pali",
  "Panipat",
  "Pilibhit",
  "Quilon",
  "Raipur",
  "Ranchi",
  "Ratlam",
  "Raurkela",
  "Rohtak",
  "Raichur",
  "Rajahmundry",
  "Rajapalaiyam",
  "Rajkot",
  "Rampur",
  "Saharanpur",
  "Salem",
  "Sambalpur",
  "Saugor",
  "Shiliguri",
  "Shillong",
  "Shimla",
  "Shimoga",
  "Shahjanpur",
  "Silchar",
  "Silvassa",
  "Sirsa",
  "Sitalpur",
  "Solapur",
  "Sonipat",
  "Sopur",
  "Srinagar",
  "Sangli",
  "Sikar",
  "Surat",
  "Tanjore",
  "Tezpur",
  "Thiruvananthapuram",
  "Tinnevelly",
  "Tirupati",
  "Tiruppur",
  "Tiruvannamalai",
  "Tonk",
  "Trichinopoly",
  "Tumkur",
  "Tuticorin",
  "Udaipur",
  "Ujjain",
  "Vadodara",
  "Vellore",
  "Vishakhapatnam",
  "Vizianagaram",
  "Valparai",
  "Varanasi",
  "Warangal",
  "agra",
  "asansol",
  "Noida"
];
export var investorType = ["Institution", "Angel", "Debt", "Corporates"];

export var ticket_size_range = [
  "10K",
  "20K",
  "30K",
  "40K",
  "50K",
  "60K",
  "70K",
  "80K",
  "90K",
  "100K",
  "150K",
  "200K",
  "250K",
  "300K",
  "350K",
  "400K",
  "450K",
  "500K",
  "750K",
  "1M",
  "1.5M",
  "2M",
  "2.5M",
  "3M",
  "3.5M",
  "4M",
  "4.5M",
  "5M",
  "7.5M",
  "10M",
  "15M",
  "20M",
  "25M",
  "30M",
  "35M",
  "40M",
  "45M",
  "50M",
  ">50M",
];

export var currentStatus = [
  "Idea",
  "MVP",
  "Pre Revenue",
  "Growth",
  "Early Revenue",
];

export var investorsPreferredChoices = [
  "PE",
  "Pre-Series A",
  "Seed",
  "Series A",
  "Series B"
];

export var whoseContactList = [
  "Vivek Kumar",
  "Vineet Sagar",
];
export var investorStatus = ["active", "inactive"];

export const startupStatusMap = {
  Sent: "Sent",
  AIC: "AIC",
  Evaluating: "Evaluating/CIP",
  Connected: "Connected/CIP",
  "Outright Rejected": "Outright Rejected",
  "Rejected with feedback": "Rejected with feedback",
  "Not Responding": "Error 1",
  "Reminder 1 Sent": "Followup process/ CIP",
  "Reminder 2 Sent": "Error 2",
  Committed: "Committed",
  Cancelled: "Cancelled",
  Closed: "Error 3",
};

export const startupStatusColorMap = {
  Sent: "primary",
  AIC: "primary",
  Evaluating: "warning",
  Connected: "info",
  "Outright Rejected": "danger",
  "Rejected with feedback": "secondary",
  "Not Responding": "danger",
  "Reminder 1 Sent": "info",
  "Reminder 2 Sent": "info",
  Committed: "success",
  Cancelled: "warning",
  Closed: "danger",
};

export const reverseStartupStatusMap = {
  Sent: "Sent",
  AIC: "AIC",
  "Evaluating/CIP": "Evaluating",
  "Connected/CIP": "Connected",
  "Outright Rejected": "Outright Rejected",
  "Rejected with feedback": "Rejected with feedback",
  "Error 1": "Not Responding",
  "Followup process/ CIP": "Reminder 1 Sent",
  "Error 2": "Reminder 2 Sent",
  Committed: "Committed",
  Cancelled: "Cancelled",
  "Error 3": "Closed",
};

export var startupStatus = [
  "Sent",
  "AIC",
  "Evaluating/CIP",
  "Connected/CIP",
  "Outright Rejected",
  "Rejected with feedback",
  "Error 1",
  "Followup process/ CIP",
  "Error 2",
  "Committed",
  "Cancelled",
  "Error 3",
];

export var mail_keywords = ["FirstName", "LastName", "Company"];
export var editorConfig = [
  "bold",
  "italic",
  "strike",
  "underline",
  "link",
  {
    formatName: "header",
    formatValues: [1, 2, 3, false],
  },
];
export var template_type = [
  "Birthday",
  "Pre Birthday",
  "Investor match",
  "Custom",
];
export var investmentType = ["Secondary", "Co-Investor"];
export var dealType = ["Secondary", "MandA", "Co-investor"];
export var priority = [
  "Level 1",
  "Level 2",
  "Strategic",
  "Network",
  "Partner",
  "LP",
  "Priority",
];
export var startupSortValues = [
  { name: "Asc in Name", value: "name" },
  { name: "Desc in Name", value: "-name" },
  { name: "Asc in Current Status", value: "current_status" },
  { name: "Desc in Current Status", value: "-current_status" },
  { name: "Asc in Industry", value: "industry" },
  { name: "Desc in Industry", value: "-industry" },
  { name: "Asc in Segment", value: "segment" },
  { name: "Desc in Segment", value: "-segment" },
  { name: "Asc in Stage", value: "stage" },
  { name: "Desc in Stage", value: "-stage" },
  { name: "Asc in Sector", value: "sector" },
  { name: "Desc in Sector", value: "-sector" },
  { name: "Asc in City", value: "city" },
  { name: "Desc in City", value: "-city" },
  { name: "Asc in Ask Amount", value: "ask_amount" },
  { name: "Desc in Ask Amount", value: "-ask_amount" },
];

export var investorSortValues = [
  { name: "Asc in Name", value: "user__username" },
  { name: "Desc in Name", value: "-user__username" },
  { name: "Asc in Primary Contact", value: "primary_contact" },
  { name: "Desc in Primary Contact", value: "-primary_contact" },
  { name: "Asc in Min. Ticket Size", value: "min_ticket_size" },
  { name: "Desc in Min. Ticket Size", value: "-min_ticket_size" },
  { name: "Asc in Max. Ticket Size", value: "max_ticket_size" },
  { name: "Desc in Max. Ticket Size", value: "-max_ticket_size" },
  { name: "Asc in Industries", value: "industries" },
  { name: "Desc in Industries", value: "-industries" },
  { name: "Asc in Stage", value: "preferred_stages" },
  { name: "Desc in Stage", value: "-preferred_stages" },
  { name: "Asc in Sector", value: "sectors" },
  { name: "Desc in Sector", value: "-sectors" },
  { name: "Asc in No Sector", value: "no_sectors" },
  { name: "Desc in No Sector", value: "-no_sectors" },
];
